import React from 'react'
import './Content.css'
import CategoryProgress from '../CategoryProgress Bar/progressbar';
import Uang from '../CategoryImages/uang.png'

const Content = ({
    key,
    name,
    need,
    expired,
    image
}) => {
    return (
        <div className="card-category">
            <div className="card-category-row">
                <div className="image-category">
                    <img className="image-cat" src={image} alt="" width="300" height="230" />
                </div>
                <div className="info-category">
                    <h6 className="category-name">{name}</h6>
                    <CategoryProgress done="70" />
                    <h6 className="category-expired">Expired-Date: {expired}</h6>
                    <div className="category-terkumpul-row">
                        <img src={Uang} alt="" width="50" />
                        <div className="category-terkumpul-column">
                            <p className="category-dana">Terkumpul<br /><b>Rp.{need}</b></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Content;
